/* eslint-disable react/no-will-update-set-state */
/* eslint-disable valid-typeof */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable func-names */
import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Helmet from 'react-helmet';
import { withTranslation } from 'react-i18next';
import PaquetesClient from '../../api/paquetes';
import Common from '../../commons/commons';
import { setPaqueteOriginal, setSearchDestinationAndOrigin } from '../../redux/actions/packages-actions';
import Contenido from './contenido';
import Filtros from '../filtros';
import ProgressBar from '../../commons/progress-bar';
import { Url } from '../../api/http-client';
import { addCityEncapsulated } from '../../redux/actions/application-actions';
import './paquetes-lista.css';
import FormBuscadorReusable from '../buscadores/form-buscador-reusable';
import { safeSessionStorage, useSessionStorage } from 'frontend/helpers/ssr-helper';

const getParams = () => {
  if (!global.expressLocation && typeof 'window' === undefined) {
    return {
      origin: '',
      destination: '',
      month: '',
      distribution: '',
      since: '',
      until: '',
    };
  }
  const { pathname, search, host } = Common.getLocationInformation();
  const urlObj = Url(`https://${host}${pathname}${search}`);
  const parts = pathname
    .replace('/buscarxpaquetes/lista-de-paquetes/', '')
    .replace('/packages/lista-de-paquetes/', '')
    .replace('/packages/list/', '')
    .split('/');
  return {
    url: `https://${host}${pathname}${search}`,
    origin: parts[0],
    destination: parts[1],
    month: parts[2],
    distribution: parts[3],
    since: urlObj.searchParams.get('desde'),
    until: urlObj.searchParams.get('hasta'),
    host,
  };
};
class ListaPaquetes extends Component {
  constructor(props) {
    super(props);
    let distribucion = 0;
    if (typeof window !== 'undefined') {
      distribucion = this.ArmarUrl().searchParams.get('h')
        ? this.ArmarUrl().searchParams.get('h')
        : isClient ? window.location.pathname : ''.split('/')[6];
    }
    this.state = {
      showFilters: false,
      filtroOperador: false,
      filtrados: [],
      cantidadPaquetes: 0,
      cantidadPasajeros: 0,
      preloader: true,
      progressNow: 0,
      showProgress: true,
      progressError: null,
      distribucion,
    };

    this.getPaquetes = this.getPaquetes.bind(this);
    this.calcularPasajeros = this.calcularPasajeros.bind(this);
    this.getPaquetePaginador = this.getPaquetePaginador.bind(this);
    this.borrarProgress = this.borrarProgress.bind(this);
    this.MostrarFiltros = this.MostrarFiltros.bind(this);
  }

  componentDidMount() {
    this.calcularPasajeros();
    this.getPaquetes();
    this.checkIfShowFilters();
  }

  checkIfShowFilters = () => {
    if (isClient ? window.innerWidth > 768 : false) {
      this.setState({
        showFilters: true,
      });
    }
  }

  toggleFilters = () => {
    this.setState((prev) => ({
      ...prev,
      showFilters: !prev.showFilters,
    }));
  }

  componentWillUpdate(nextProps) {
    if (nextProps !== this.props) {
      const { filtrados } = nextProps.packages;
      if (filtrados !== undefined && filtrados !== this.state.filtrados) {
        this.setState({ filtrados });
      }
    }
  }

  getPaquetePaginador() {
    this.setState({
      preloader: true,
    });
    this.getPaquetes();
  }

  getPaquetes() {
    const request = this.ArmarRequestBusqueda();
    const _this = this;
    const { token } = this.props;
    let uniqueExecution = true;
    PaquetesClient.obtenerPaquetes(request, token,
      (res) => {
        // Se guarda el destino que viene en la respuesta de paquetes solo una ves
        if (uniqueExecution) {
          _this.props.setSearchDestinationAndOrigin(res.data.ciudades);
          uniqueExecution = false;
        }
        _this.props.setPaqueteOriginal(res.data.paquetes);
        _this.setState({
          cantidadPaquetes: res.data.paginado.totalRegistros,
          progressNow: _this.state.progressNow + res.data.paquetes.length,
          preloader: false,
        });
      },
      () => {

        if (parseInt(_this.state.cantidadPaquetes) === 0) {
          _this.setState({
            preloader: false,
            filtrados: [],
          });
        } else {
          _this.setState({
            progressError: 'Por un Error no pudimos traer todos los paquetes de este destino, podemos intentarlo nuevamente si recargas la página',
            progressNow: _this.state.cantidadPaquetes,
          });
        }

      });
  }

  calcularPasajeros() {
    const distribucion = Common.obtenerDistribucion();
    const cantPasajeros = Common.obtenerCantidadPasajeros(distribucion);
    this.setState({
      cantidadPasajeros: cantPasajeros,
    });
  }

  ArmarRequestBusqueda() {
    const urlActual = this.ArmarUrl();
    const urlProps = isClient ? window.location.pathname : ''.split('/');
    return {
      FechaDesde: urlActual.searchParams.get('desde'),
      FechaHasta: urlActual.searchParams.get('hasta'),
      CodigoOrigen: urlProps[3],
      CodigoDestino: urlProps[4],
      Distribucion: urlProps[6],
      Pagina: 1,
      PaquetesPorPagina: process.env.RAZZLE_PAQUETES_POR_PAGINA,
    };
  }

  ArmarUrl = () => {
    const urlString = isClient ? window.location.href : '';
    return Url(urlString);
  }

  borrarProgress() {
    this.setState({ showProgress: false });
  }

  CalcularProgress = (ahora, total) => {
    return ((ahora * 80) / total) + 20;
  }

  ObtenerNombreDeLugar = (lugar) => {
    const item = safeSessionStorage.getItem(lugar);
    if (item != null) {
      return JSON.parse(item).name;
    } return '';
  }

  MostrarFiltros() {
    return (this.state.cantidadPaquetes > 0);
  }

  createSeoElements() {
    const { t } = this.props;
    const params = getParams();
    const { nombre, cities } = this.props.application;
    const { origin, destination, monthString } = this.props.match.params;

    const destino = cities.filter((city) => destination === city.code)[0] || { name: destination };
    const origen = cities.filter((city) => origin === city.code)[0] || { name: origin };
    const mes = (monthString.charAt(0) || '').toUpperCase() + monthString.slice(1);

    const title = `${t('packages.packagesFrom')} ${origen.name} ${t('packages.until')} ${destino.name} ${t('packages.in')} ${mes} | ${nombre}`;
    const description = `${t('packages.packagesTo')} ${destino.name} ${t('packages.since')} ${origen.name} ${t('packages.in')} ${mes}`;
    const h1 = `${t('packages.packagesTo')} ${destino.name}, ${mes}, ${t('packages.travelTo')} ${destino.name}`;
    return {
      metaTags: (
        <Helmet>
          <title>{ title }</title>
          <meta name='description' content={description} />
          <meta property='og:title' content={title} />
          <meta property='og:description' content={description} />
          <meta property='og:url' content={params.url} />
        </Helmet>
      ),
      h1: (
        <Fragment>
          <h1 className='s-h1 mb-4'>{ h1 }</h1>
        </Fragment>
      ),
    };
  }

  render() {
    const { t } = this.props;
    const { metaTags, h1 } = this.createSeoElements();

    const {
      filtrados, filtroOperador, progressNow, cantidadPaquetes, showProgress, showFilters,
    } = this.state;

    let progressLabel = '';
    let origenDisplay = '';

    if (filtrados.length !== 0 && filtrados[0].salidas) {
      origenDisplay = filtrados[0].salidas[0].origen === filtrados[0].salidas[0].origenIata
        ? this.ObtenerNombreDeLugar(filtrados[0].salidas[0].origenIata)
        : filtrados[0].salidas[0].origen;

      progressLabel = progressNow < cantidadPaquetes
        ? `${t('packages.searching')} ${progressNow}`
        : `${t('packages.found', { cp: this.state.cantidadPaquetes, destino: this.state.filtrados[0].salidas[0].destino, origen: this.state.origenDisplay })}`;
    }

    if (this.state.progressError) {
      progressLabel = this.state.progressError;
    }

    const progress = this.CalcularProgress(progressNow, cantidadPaquetes);

    if (cantidadPaquetes != 0 && progressNow == cantidadPaquetes && showProgress && !this.state.progressError) {
      _.delay(this.borrarProgress, 5000);
    }

    return (
      <div>
        { metaTags }
        <React.Fragment>
          <div className='listado-paquetes'>
            <div className='listado'>
              <div className='container py-12'>
                { h1 }
                <div className='grid grid-cols-12 gap-8'>
                  <div className='col-span-12 md:col-span-3'>
                    <div className='package-searcher-container shadow-md rounded-lg md:rounded-md mb-8'>
                      <div className='package-searcher rounded-lg md:rounded px-5 py-5 md:px-4 md:py-3'>
                        <div className='seacher-form-container'>
                          <FormBuscadorReusable />
                        </div>
                      </div>
                    </div>
                    <button
                      type='button'
                      onClick={this.toggleFilters}
                      className='btn-toggle-filters flex justify-center
                      items-center md:hidden w-full py-3 rounded mb-5'
                    >
                      <span>{t('packages.filters')}</span>
                      <i className='ml-2 fas fa-sort-amount-down-alt' />
                    </button>
                    {typeof window !== 'undefined' && (
                      <div className={`filters-container ${showFilters ? 'block' : 'hidden'}`}>
                        <Filtros
                          mostrarOperador={filtroOperador}
                          cantidadPasajeros={this.state.cantidadPasajeros}
                          show={cantidadPaquetes !== 0}
                        />
                      </div>
                    )}
                  </div>
                  <div className={this.state.preloader ? 'col-span-12 md:col-span-6 ' : 'col-span-12 md:col-span-9'}>
                    {
                      showProgress && filtrados.length !== 0
                        ? (
                          <div className='progressBar'>
                            <ProgressBar label={progressLabel} progress={progress} />
                          </div>
                        )
                        : (null)
                    }

                    {filtrados !== undefined
                      ? (
                        <Contenido
                          buscarPaquetes={this.getPaquetePaginador}
                          distribucion={this.state.distribucion}
                          preloader={this.state.preloader}
                          paquetes={filtrados}
                          cantidadPaquetes={this.state.cantidadPaquetes}
                          cantidadPasajeros={this.state.cantidadPasajeros}
                        />
                      )
                      : (null)}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    );
  }
}

const cityOrigin = () => (dispatch) => {
  const params = getParams();
  return addCityEncapsulated(params.origin, dispatch);
};

const cityDestination = () => (dispatch) => {
  const params = getParams();
  return addCityEncapsulated(params.destination, dispatch);
};

ListaPaquetes.serverFetch = [cityOrigin, cityDestination];

const mapStateToProps = function (store) {
  return {
    packages: store.packages,
    token: store.applicationState.token,
    application: store.applicationState,
  };
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    setPaqueteOriginal,
    setSearchDestinationAndOrigin,
    addCityEncapsulated,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(['layout'])(ListaPaquetes));
